import { render, staticRenderFns } from "./Diferenciais.vue?vue&type=template&id=c0738f3c&scoped=true&lang=pug&"
import script from "./Diferenciais.vue?vue&type=script&lang=js&"
export * from "./Diferenciais.vue?vue&type=script&lang=js&"
import style0 from "./Diferenciais.styl?vue&type=style&index=0&id=c0738f3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0738f3c",
  null
  
)

export default component.exports